module.exports = __webpack_public_path__ + "img/Khalid.e454cb65.webp";